import Creator from "./Creator";
import Checker from "./Checker";

export default class CreatorForm {
    private creator: Creator;

    public $bypass_checks: JQuery = $();
    public bypass_checkers = false;
    public bypass_update = false;

    public constructor(creator: Creator) {
        this.creator = creator;
    }

    public getInput(name: string): JQuery {
        let $input = $('input[name="' + name + '"]', this.creator.$el);

        return $input;
    }

    public getValue(name: string): string {
        let $input = this.getInput(name);

        return $input.val();
    }

    public getValueInt(name: string): number {
        return parseInt(this.getValue(name));
    }

    public getCheck(selector: string): Checker {
        return $(selector, this.creator.$el).data('xcheck');
    }

    public getCheckByName(name: string): Checker {
        let $input = this.getInput(name);

        return $input.closest('.xcheck').data('xcheck');
    }

    public getData(): any {
        let data = this.creator.$el.find(':input:not(:disabled)').serializeArray();

        return data;
    }
}
